import request from '@/utils/request'
import storage from 'store'
import {TENANT} from '@/store/mutation-types'

const api = {
  ssoUrl: "/auth/getSsoAuthUrl",
  ssoTicket: "/auth/getSsoTicket"
}


export function getAuthorizeUrl(appId, redirectUrl) {
  return request({
    url: api.ssoUrl,
    method: "get",
    params: {
      client: appId,
      redirectUrl: redirectUrl
    }
  })
}

/**
 * 获取sso ticket url
 *
 * @author guwenbo
 **/
export function getSsoTicket(params){
  return request({
    url: api.ssoTicket,
    method: 'get',
    params: params
  })
}
